import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="container footer-columns">
          <div className="footer-col about">
            <h3>About Us</h3>
            <p>
              We only carry designs we believe in ethically and aesthetically —
              original, authentic pieces that are made to last.
            </p>
            <Link to="/about" onClick={toTop} className="learn-more">
              Learn More
            </Link>
          </div>

          <div className="footer-col">
            <h4>Orders</h4>
            <ul>
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Return
                </Link>
              </li>

              <li>
                <Link to="/privacy" onClick={toTop}>
                  Do not share my information
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Customer care</h4>
            <ul>
              <li>
                <Link to="/about" onClick={toTop}>
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col newsletter">
            <p>cart@cartnovabin.shop</p>
            <p>Lobo Estepario 20008, Los Lobos, 22207 Tijuana, B.C., Mexico</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-row">
          <div className="bottom-left">
            <p>© 2026 Cartnovabin. All Rights Reserved.</p>
            <button className="promo-btn">GET 10% OFF</button>
          </div>

          <div className="bottom-center">
            <nav className="footer-links">
              <Link to="/returns" onClick={toTop}>
                Refund policy
              </Link>
              <Link to="/privacy" onClick={toTop}>
                Privacy policy
              </Link>
              <Link to="/terms" onClick={toTop}>
                Terms of service
              </Link>
              <Link to="/shipping" onClick={toTop}>
                Shipping policy
              </Link>
              <Link to="/contact" onClick={toTop}>
                Contact information
              </Link>
            </nav>
          </div>

          <div className="bottom-right">
            <div className="socials">
              <a
                href="https://facebook.com"
                aria-label="Facebook"
                target="_blank"
                rel="noreferrer"
              >
                f
              </a>
              <a
                href="https://instagram.com"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                ig
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
